<template>
  <div>
    <page-header :title="$t('system.global_topology')" :tabs="types" :current-tab.sync="type">
      <div slot="res-status-tab">
        <fixed-label-filter :label="$t('dictionary.domain')">
          <base-select
           v-model="domainId"
           resource="domains"
           minWidth="150px"
           width="150px"
           remote
           :mapper="mapper"
           :params="{ limit: 20, scope: $store.getters.scope }" />
        </fixed-label-filter>
      </div>
    </page-header>
    <page-body>
      <!-- <res-topology :dataSource="dataSource" :loading="loading" /> -->
      <component :is="type" :dataSource="dataSource" :loading="loading" :domainId="domainId" />
    </page-body>
  </div>
</template>

<script>
// import Mock from 'mockjs'
import ResTopology from './components/ResTopology'
import ResTopology2 from './components/ResTopology2'

export default {
  name: 'GlobalTopology',
  components: {
    ResTopology,
    ResTopology2,
  },
  data () {
    return {
      loading: false,
      dataSource: {},
      types: [
        { key: 'res-topology2', label: this.$t('system.tree_topology') },
        { key: 'res-topology', label: this.$t('system.lateral_topology') },
      ],
      type: 'res-topology2',
      domainId: 'all',
    }
  },
  watch: {
    type () {
      this.fetchTopology()
    },
    domainId () {
      this.fetchTopology()
    },
  },
  created () {
    this.manager = new this.$Manager('global_topology', 'v1')
    this.fetchTopology()
  },
  mounted () {
  },
  methods: {
    mapper (list) {
      return [{ id: 'all', name: this.$t('common_95') }, ...list]
    },
    fetchTopology () {
      this.loading = true
      this.dataSource = {}
      this.manager.list({
        params: {
          scope: this.$store.getters.scope,
          simple: this.type === 'res-topology',
          domain: this.domainId === 'all' ? '' : this.domainId,
        },
      }).then((res) => {
        const data = res.data?.data || []
        this.dataSource = this.arrangeData(data[0] || {})
        // const Random = Mock.Random
        // const d = Mock.mock({
        //   'accounts|0-2': [{
        //     'id|+1': 1,
        //     name: Random.name(),
        //     'hosts|3-10': [{
        //       'id|+10': 10,
        //       name: Random.name(),
        //       'servers|0-20': [{
        //         'id|+100': 100,
        //         name: Random.name(),
        //       }],
        //       'isolate_devices|0-2': [{
        //         'id|200': 200,
        //         name: Random.name(),
        //       }],
        //     }],
        //   }],
        // })
        // this.dataSource = this.arrangeData(d)
        this.loading = false
      }).catch((err) => {
        this.loading = false
        throw err
      })
      // const Random = Mock.Random
      // const data = Mock.mock({
      //   'accounts|1-10': [{
      //     'id|+1': 1,
      //     name: Random.name(),
      //     'hosts|3-10': [{
      //       'id|+10': 10,
      //       name: Random.name(),
      //       'servers|0-20': [{
      //         'id|+100': 100,
      //         name: Random.name(),
      //       }],
      //       'isolate_devices|0-10': [{
      //         'id|200': 200,
      //         name: Random.name(),
      //       }],
      //     }]
      //   }],
      // })
      // console.log(data)
    },
    arrangeData (data) {
      const obj = { accounts: [], ...data }
      obj.accounts = obj.accounts.map(account => {
        if (account.hosts) {
          account.hosts = account.hosts.map((host, index) => {
            if (host.servers) {
              host.servers.map(server => {
                server.owner_type = 'servers'
                host.vcpu_count = (host.vcpu_count || 0) + (server.vcpu_count || 0)
                host.vmem_size = (host.vmem_size || 0) + (server.vmem_size || 0)
              })
            } else {
              host.servers = []
            }
            if (host.isolate_devices) {
              host.isolate_devices.map(iso => {
                iso.owner_type = 'gpu'
              })
            } else {
              host.isolate_devices = []
            }
            account.cpu_count = (account.cpu_count || 0) + (host.cpu_count || 0)
            account.mem_size = (account.mem_size || 0) + (host.mem_size || 0)
            account.vcpu_count = (account.vcpu_count || 0) + (host.vcpu_count || 0)
            account.vmem_size = (account.vmem_size || 0) + (host.vmem_size || 0)
            account.server_count = (account.server_count || 0) + (host.servers || []).length
            account.gpu_count = (account.gpu_count || 0) + (host.isolate_devices || []).length
            account.gpu_used_count = (account.gpu_used_count || 0) + (host.isolate_devices || []).filter(item => item.guest_id).length
            return host
          })
          account.hosts = [...account.hosts]
        }
        obj.cpu_count = (obj.cpu_count || 0) + (account.cpu_count || 0)
        obj.mem_size = (obj.mem_size || 0) + (account.mem_size || 0)
        obj.vcpu_count = (obj.vcpu_count || 0) + (account.vcpu_count || 0)
        obj.vmem_size = (obj.vmem_size || 0) + (account.vmem_size || 0)
        obj.host_count = (obj.host_count || 0) + ((account.hosts || []).length)
        obj.server_count = (obj.server_count || 0) + (account.server_count || 0)
        obj.gpu_count = (obj.gpu_count || 0) + (account.gpu_count || 0)
        obj.gpu_used_count = (obj.gpu_used_count || 0) + (account.gpu_used_count || 0)
        return account
      })
      return obj
    },
  },
}
</script>
